// ============================================================
// DATI DEL CENTRO — modifica qui telefono, email e indirizzo.
// Questi valori sono segnaposto: sostituiscili con i dati reali.
// ============================================================
export const SITE = {
  name: "Centro Studi Forma Futuro",
  shortName: "Forma Futuro",
  tagline: "Il tuo percorso, il nostro supporto.",
  phone: "+39 340 710 5493",
  whatsapp: "393407105493",
  email: "formafuturo48@gmail.com",
  address: "Capaccio Paestum (SA)",
  logo: "/assets/logo-prestige-color.png",
  logoWhite: "/assets/logo-prestige-white.png",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Percorsi", to: "/percorsi" },
  { label: "Diplomi", to: "/diplomi" },
  { label: "Università", to: "/lauree" },
  { label: "Formazione", to: "/formazione-professionale" },
  { label: "Certificazioni", to: "/certificazioni" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "Contatti", to: "/contatti" },
];
